import { useStaticQuery, graphql } from 'gatsby'

export const getSelectedArticleTitle = title => {
  const { allStrapiArticle } = useStaticQuery(allArticlesQuery)
  const selectedArticleTitle = allStrapiArticle.nodes.filter(
    article => article.title === title
  )
  return (
    selectedArticleTitle
  )
}

const allArticlesQuery = graphql`
  query {
    allStrapiArticle {
      nodes {
        title
        updatedAt
      }
    }
  }
`